import { defaultTo } from "lodash";
import { IModel, ISalesItemOptionTagAlongListingModel, Model, SalesItemOptionTagAlongListingModel } from ".";

export interface ISalesItemOptionModel extends IModel {
    salesItemOptionId: number;
    salesItemId: number;
    name: string;
    displayName: string;
    reminderDays: number | undefined;
    sortOrder: number;
    code: string;
    prescriptionLabelId: number | undefined;
    // salesItem: SalesItemModel;
    refills: number | undefined;
    packageQuantity: number | undefined;
    additionalInfoLabelId: number | undefined;
    prescriptionFulfillmentId: number | undefined;
    petcoSKU: string;
    allowPartialQuantities: boolean;
    allowQuantityChanges: boolean;
    allowQuantityRanges: boolean;
    defaultQuantity: number;
    minimumQuantity: number;
    maximumQuantity: number;
    unitOfMeasureId: number;
    unitOfMeasureQuantity: number;
    allowUserEnteredPrice: boolean;
    tagAlongs: ISalesItemOptionTagAlongListingModel[];
    clinicSKU: string;
    hospitalSKU: string;
    dosesSold: number | undefined;
}

export class SalesItemOptionModel extends Model implements Record<keyof ISalesItemOptionModel, any> {
    salesItemOptionId: number;
    salesItemId: number;
    name: string;
    displayName: string;
    reminderDays: number | undefined;
    sortOrder: number;
    code: string;
    prescriptionLabelId: number | undefined;
    refills: number | undefined;
    packageQuantity: number | undefined;
    additionalInfoLabelId: number | undefined;
    prescriptionFulfillmentId: number | undefined;
    petcoSKU: string;
    allowPartialQuantities: boolean;
    allowQuantityChanges: boolean;
    allowQuantityRanges: boolean;
    defaultQuantity: number;
    minimumQuantity: number;
    maximumQuantity: number;
    unitOfMeasureId: number;
    unitOfMeasureQuantity: number;
    allowUserEnteredPrice: boolean;
    tagAlongs: SalesItemOptionTagAlongListingModel[];
    clinicSKU: string;
    hospitalSKU: string;
    defaultStartDate?: string;//UI Field Only
    dosesSold: number | undefined;
    constructor(params?: Partial<ISalesItemOptionModel>) {
        super(params);
        this.salesItemOptionId = defaultTo(params?.salesItemOptionId, 0);
        this.salesItemId = defaultTo(params?.salesItemId, 0);
        this.name = defaultTo(params?.name, '');
        this.displayName = defaultTo(params?.displayName, '');
        this.reminderDays = defaultTo(params?.reminderDays, undefined);
        this.sortOrder = defaultTo(params?.sortOrder, 0);
        this.code = defaultTo(params?.code, '');
        this.prescriptionLabelId = defaultTo(params?.prescriptionLabelId, undefined);
        this.refills = defaultTo(params?.refills, undefined);
        this.packageQuantity = defaultTo(params?.packageQuantity, undefined);
        this.additionalInfoLabelId = defaultTo(params?.additionalInfoLabelId, undefined);
        this.prescriptionFulfillmentId = defaultTo(params?.prescriptionFulfillmentId, undefined);
        this.petcoSKU = defaultTo(params?.petcoSKU, '')
        this.allowPartialQuantities = defaultTo(params?.allowPartialQuantities, false);
        this.allowQuantityRanges = defaultTo(params?.allowQuantityRanges, false);
        this.allowQuantityChanges = defaultTo(params?.allowQuantityChanges, false);
        this.defaultQuantity = defaultTo(params?.defaultQuantity, 1);
        this.minimumQuantity = defaultTo(params?.minimumQuantity, 1);
        this.maximumQuantity = defaultTo(params?.maximumQuantity, 1);
        this.unitOfMeasureId = defaultTo(params?.unitOfMeasureId, 7);
        this.unitOfMeasureQuantity = defaultTo(params?.unitOfMeasureQuantity, 1);
        this.allowUserEnteredPrice = defaultTo(params?.allowUserEnteredPrice, false);
        this.tagAlongs = (params?.tagAlongs ?? []).map(t => new SalesItemOptionTagAlongListingModel(t));
        this.defaultStartDate = new Date().toISOString();
        this.clinicSKU = defaultTo(params?.clinicSKU, '');
        this.hospitalSKU = defaultTo(params?.hospitalSKU, '');
        this.dosesSold = _.defaultTo(params?.dosesSold, undefined);
    }
}
